import { date, nullable, pipe, string, transform } from 'valibot'

// Date→string型への変換を含む、日付のnullableなスキーマ
export const nullableDateToStringSchema = pipe(
  nullable(date()),
  // Date型だった場合stringに変換
  transform((v) => (v instanceof Date ? v.toISOString() : null)),
  nullable(string())
)
